/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */

import { createAction } from '../app/createAction';
import {
    SET_EXPORT_FORMAT,
    START_EXPORT,
} from './exportConstants';
import {
    ISetExportFormat,
    ISetExportFormatPayload,
    IStartExport,
} from './exportTypes';

export const setExportFormat = (payload: ISetExportFormatPayload): ISetExportFormat =>
    createAction(SET_EXPORT_FORMAT, payload);

export const startExport = (payload: string): IStartExport =>
    createAction(START_EXPORT, payload);
